import AsyncStorage from '@react-native-async-storage/async-storage';
import type { ICFLevel } from '../types';

const KEY = 'analysis_prefs_v1';
export interface AnalysisPreferences {
    language?: 'tr' | 'en';
    requestedLevel?: ICFLevel;
    includeMarkerTable?: boolean;
}

export async function loadAnalysisPreferences(): Promise<AnalysisPreferences> {
    try {
        const value = JSON.parse(await AsyncStorage.getItem(KEY) || '{}');
        return {
            language: value?.language === 'en' || value?.language === 'tr' ? value.language : undefined,
            requestedLevel: ['auto', 'acc', 'pcc', 'mcc'].includes(value?.requestedLevel) ? value.requestedLevel : undefined,
            includeMarkerTable: typeof value?.includeMarkerTable === 'boolean' ? value.includeMarkerTable : undefined,
        };
    } catch { return {}; }
}

export async function saveAnalysisPreferences(preferences: AnalysisPreferences, mode: 'coach' | 'engagement'): Promise<void> {
    try {
        const previous = await loadAnalysisPreferences();
        const next = mode === 'engagement' ? { ...previous, language: preferences.language } : preferences;
        await AsyncStorage.setItem(KEY, JSON.stringify(next));
    } catch { /* Preferences must never prevent analysis. */ }
}
